import SkeletonElement from "./SkeletonElement";

type MetricListItemSkeletonProps = {
  className?: string;
};

export default function MetricListItemSkeleton({ className = "" }: MetricListItemSkeletonProps) {
  return (
    <div className={`flex justify-between w-full min-w-0 my-2 ${className}`} data-testid="metric-list-item-skeleton">
      <div className="items-start flex space-x-2 w-full min-w-0">
        <SkeletonElement height="h-10" width="w-10" rounded="rounded-[6px]" className="flex-shrink-0 mr-2" />
        <div className="flex flex-col items-start min-w-0 flex-1 gap-1">
          <SkeletonElement height="h-4" width="w-16" />
          <SkeletonElement height="h-6" width="w-24" />
        </div>
      </div>
    </div>
  );
}
